<template>
  <div class="new-exam">
    <card-form :collapsed="false">
      <div slot="collapsed">
        <md-layout
          md-flex="100"
          md-flex-medium="100"
        >
          <h2
            id="patientFormTitle"
            class="voucher-new__patient__title voucher-new__patient__title-collapsed title-main"
          >
            Exames
            Disponíveis
          </h2>
        </md-layout>

        <md-layout
          v-if="getVoucherLoadingExamStatus !== 'STATUS_SUCCESS'"
          class="exam-voucher__curves"
          md-flex="100"
        >
          <spinner />
        </md-layout>

        <md-layout
          v-else
          class="exam-voucher__curves"
        >
          <div class="exam-voucher__curves__items">
            <div
              v-for="(item) in availableExamsForVoucher"
              :key="item.id"
              class="exam-voucher__curves__item"
            >
              <md-tooltip
                class="tooltip"
                md-direction="top"
              >
                {{ item.name }}
              </md-tooltip>
              <div class="styled-checkbox-primary-color">
                <input
                  :id="'chbxID' + item.id"
                  v-model="selected"
                  type="checkbox"
                  :value="item"
                  :disabled="examsLeft === 0 && !isChecked(item)"
                >
                <label :for="'chbxID' + item.id" />
              </div>
              <label
                :for="'chbxID' + item.id"
                :title="item.code"
                class="exam-voucher__curves__item__label"
                :class="{'exam-disabled': !isVoucherInactive}"
              >{{ item.code }}</label>
            </div>
          </div>
        </md-layout>
      </div>
    </card-form>
    <p
      v-if="selected.length == 0"
      class="search__message"
    >
      Nenhum exame adicionado para a OS.
    </p>
    <div
      v-for="(item, index) in newExamsList"
      v-else
      :key="item.componentUniqUid"
      :class="['search-results__exams', 'exam-card-num-' + index]"
    >
      <component
        :is="examComponent[item.type]"
        :index="index"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
import CommonExam from '@/components/Exams/Create/CommonExam'
import AdditionalExam from '@/components/Exams/Create/AdditionalExam'
import CurveExam from '@/components/Exams/Create/CurveExam'
import MaternityExam from '@/components/Exams/Create/MaternityExam'
import PaternityExam from '@/components/Exams/Create/PaternityExam'
import LoadingExam from '@/components/Exams/LoadingExam'
import { mapGetters, mapActions } from 'vuex'
import Spinner from '@/components/common/Spinner'
import CardForm from '@/components/common/CardForm'

export default {
  name: 'VoucherExamsNew',
  components: {
    'common-exam': CommonExam,
    'additional-exam': AdditionalExam,
    'curve-exam': CurveExam,
    'maternity-exam': MaternityExam,
    'paternity-exam': PaternityExam,
    'loading-exam': LoadingExam,
    'spinner': Spinner,
    'card-form': CardForm
  },
  props: ['examsLeft'],
  data: () => {
    return {
      examComponent: {
        'LOADING': 'loading-exam',          // Exame loading
        'STANDARD': 'common-exam',          // Exame comum
        'ADDITIONAL': 'additional-exam',    // Exame complementar
        'CURVE': 'curve-exam',              // Exame de curva
        'MATERNITY': 'maternity-exam',      // Exame de Paternidade
        'PATERNITY': 'paternity-exam'       // Exame de Paternidade
      }
    }
  },
  methods: {
    ...mapActions(['setSelectedExams']),
    ...mapActions(['clearAllVoucherData']),
    isChecked (item) {
      return this.selected.includes(item)
    },
    syncDeletedExam () {
      let newExamListIds
      if (this.newExamsList.length !== this.selected.length) {
        newExamListIds = this.newExamsList.map(function (item) {
          return item.id
        })
        this.selected = this.selected.filter(x => newExamListIds.includes(x.id))
      }
    }
  },
  computed: {
    ...mapGetters(['availableExamsForVoucher']),
    ...mapGetters(['getVoucherLoadingExamStatus']),
    ...mapGetters(['getSelectedVoucherExams']),
    ...mapGetters(['newExamsList']),
    ...mapGetters(['isVoucherInactive']),
    selected: {
      get: function () {
        return this.getSelectedVoucherExams
      },
      set: function (item) {
        this.setSelectedExams(item)
      }
    }
  },
  watch: {
    newExamsList: function () {
      this.syncDeletedExam()
    }
  },
  beforeDestroy () {
    this.clearAllVoucherData()
  },
  created () {
    this.clearAllVoucherData()
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/mixins';

  .tooltip {
    max-width: 310px;
    white-space: initial;
  }

  .new-exam {

    .md-input-container {
      &.search {
        margin: 0 0 20px;
        padding: 0;
        min-height: 39px;

        &:after {
          display: none;
        }

        .search {
          &__label {
            position: relative;
            display: flex;
            align-items: center;
            float: left;
            width: 105px;
            top: inherit;
            left: inherit;
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 1.1px;
            color: #727272;
          }

          &__input-container {
            position: relative;
            display: block;
            width: calc(100% - 105px);
          }
        }
      }
    }

    .exam-disabled {
      opacity: .6;
      cursor: not-allowed
    }

    .exam-curve__container .exam-curve__curves__item {
      width: 8%;
    }

    .search {
      &__message {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 10px 0;
        height: 110px;
        font-size: 15px;
        line-height: 1.5;
        color: #969696;
      }

      &-results__exams {
        margin: 22px 0 20px;

        .multiselect {
          &__content-wrapper {
            max-height: 150px !important;
          }
        }
      }
    }

  }

  @keyframes fadeout {
    0% {
      opacity: 1;
    }
    99% {
      opacity: 0;
    }
    100% {
      display: none;
    }
  }
  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
</style>
